import script from "./DesktopSearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopSearchBar.vue?vue&type=script&setup=true&lang=ts"

import "./DesktopSearchBar.vue?vue&type=style&index=0&id=72481353&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72481353"]])

export default __exports__